'use client';
import React from 'react';
import Link from 'next/link';

const footerLinks = [
  { label: 'The Fleet Cap', href: '#fleet-cap' },
  { label: 'The Hospitality Suite', href: '#hospitality' },
  { label: 'Executive Utility', href: '#executive' },
  { label: 'Margin Math', href: '#margin-math' },
  { label: 'Why Tactile', href: '#why-tactile' },
  { label: 'FAQ', href: '#faq' },
];

const legalLinks = [
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms of Service', href: '#' },
  { label: 'Shipping Policy', href: '#' },
];

export default function Footer() {
  return (
    <footer
      role="contentinfo"
      style={{
        backgroundColor: 'rgb(3, 8, 16)',
        borderTop: '1px solid rgba(0, 180, 255, 0.2)',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link href="/" className="flex items-center mb-3 group">
              <img
                src="/assets/images/swag_long-1784503562979.png"
                alt="Serious Swag Logo"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p
              className="text-sm leading-relaxed"
              style={{ color: 'rgb(136, 147, 152)' }}
            >
              Premium 3D-Textured Corporate Merchandise
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4
              className="font-montserrat font-bold uppercase text-white text-xs mb-4"
              style={{ letterSpacing: '2px' }}
            >
              Product Suite
            </h4>
            <div className="flex flex-col gap-2">
              {footerLinks?.map((link) => (
                <a
                  key={link?.label}
                  href={link?.href}
                  className="text-sm transition-colors duration-200 hover:text-white"
                  style={{ color: 'rgb(136, 147, 152)' }}
                >
                  {link?.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="font-montserrat font-bold uppercase text-white text-xs mb-4"
              style={{ letterSpacing: '2px' }}
            >
              Contact
            </h4>
            <div className="flex flex-col gap-2">
              <a
                href="mailto:hello@seriousswag.com"
                className="text-sm transition-colors duration-200 hover:text-white"
                style={{ color: 'rgb(136, 147, 152)' }}
              >
                hello@seriousswag.com
              </a>
              <a
                href="tel:+18005551234"
                className="text-sm transition-colors duration-200 hover:text-white"
                style={{ color: 'rgb(136, 147, 152)' }}
              >
                (800) 555-1234
              </a>
              <div className="flex gap-3 mt-2">
                {['LinkedIn', 'Instagram', 'Twitter']?.map((social) => (
                  <a
                    key={social}
                    href="#"
                    className="text-xs font-montserrat font-bold uppercase transition-colors duration-200 hover:text-white"
                    style={{ color: 'rgb(136, 147, 152)', letterSpacing: '0.5px' }}
                  >
                    {social}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ borderColor: 'rgba(0, 180, 255, 0.1)' }}
        >
          <p
            className="text-xs"
            style={{ color: 'rgb(136, 147, 152)' }}
          >
            &copy; 2025 Serious Swag Inc. &mdash; All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            {legalLinks?.map((link) => (
              <a
                key={link?.label}
                href={link?.href}
                className="text-xs transition-colors duration-200 hover:text-white"
                style={{ color: 'rgb(136, 147, 152)' }}
              >
                {link?.label}
              </a>
            ))}
          </div>
          <p
            className="text-xs"
            style={{ color: 'rgb(136, 147, 152)' }}
          >
            Built with{' '}
            <span
              className="font-bold"
              style={{ color: '#ff6b35' }}
            >
              Serious
            </span>{' '}
            leverage.
          </p>
        </div>
      </div>
    </footer>
  );
}
